export default "__VITE_ASSET__CPwiP$a1__"